export const sort = [
  { label: "Nazwa", name: "name" },
  { label: "Identyfikator", name: "identifier" },
  {
    label: "Domyślny kurs w sugerowaniu ceny",
    name: "default_suggested_price_exchange_rate",
  },
];

export const filters = [
  {
    type: "input",
    name: "name",
    sort_id: "name",
    search_type: "matches",
  },
  {
    type: "input",
    name: "identifier",
    sort_id: "identifier",
    search_type: "matches",
  },
  {
    type: "input",
    name: "default_suggested_price_exchange_rate",
    sort_id: "default_suggested_price_exchange_rate",
    search_type: "matches",
  },
];
